<template>
    <div class="container mx-auto flex justify-center py-10"
        v-if="hasUser()">
      <div class="w-full md:w-70-p lg:px-12 xl:px-16">
      <div
        class="py-12 bg-center bg-no-repeat bg-cover sm:bg-contain rounded"
        style="background-image: url('/storage/image/banner-profile-subscribe.webp')"
      >
        <div class="container mx-auto flex flex-col items-center justify-center px-4">
          <div class="text-jblue-primary font-shadow-sm font-extrabold text-2xl mb-2 text-center">{{ $t('messages.upgrade.title')}}</div>
          <p class="text-jblue-secondary font-shadow-sm font-bold text-base w-2/3 mx-auto mb-4 text-center" v-html="$t('messages.upgrade.description')"></p>
          <button
            class="mx-3 font-semibold bg-premium text-jblue-primary rounded focus:outline-none"
            :disabled="gettingSessionId"
            @click="doSecurePayment()"
          >
            <template v-if="gettingSessionId">
              <spinner :size="25" />
            </template>
            <template v-else>{{
              $t("messages.upgrade.become_premium")
            }}</template>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import get from 'lodash/get';

export default {
  name: "SubscriptionUpgrade",
  props: {
    guestMode: Boolean,
    hideButton: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      gettingSessionId: false
    }
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("locale", ["locale"])
  },
  methods: {
    ...mapActions("profiles", ["getUpgradeSession"]),
    async doSecurePayment() {
      this.gettingSessionId = true;

      const id = await this.getUpgradeSession({
        lang: this.locale
      });

      const stripe = Stripe(process.env.MIX_STRIPE_KEY);

      const { error } = await stripe.redirectToCheckout({
        sessionId: id
      });
    },
    hasUser() {
      if (get(this.user, 'id', 0) > 0) {
        return (this.user.subscription_status === 'active' && this.user.subscription_type === 'subscribed' && !this.user.with_gift);
      } else {
        return true;
      }
    },
  }
};
</script>

<style scoped lang="scss">
.bg-premium {
    background: linear-gradient(90deg, #FFC107 0%, #FFEB3B 100%);
}
.font-shadow-sm {
  text-shadow: 0px 1px 2px rgba(0,0,0,0.2);
}

.md\:w-70-p {
  @media only screen and (min-width: 768px) {
    width: 77%;
  }
}
</style>
